type Subscriber<EventType> = (event: EventType) => void;

export default function Subscription<EventType>() {
  let subscribers: Subscriber<EventType>[] = [];

  function addSubscriber(subscriber: Subscriber<EventType>) {
    if (!subscribers.includes(subscriber)) {
      subscribers.push(subscriber);
    }
  }

  function removeSubscriber(subscriber: Subscriber<EventType>) {
    const index = subscribers.indexOf(subscriber);

    if (index !== -1) {
      subscribers.splice(index, 1);
    }
  }

  function notifySubscribers(event: EventType) {
    for (const subscriber of subscribers) {
      subscriber(event);
    }
  }

  function removeAllSubscribers() {
    subscribers = [];
  }

  return {
    addSubscriber,
    removeSubscriber,
    removeAllSubscribers,
    notifySubscribers,
  };
}
